import React, { Fragment, useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import API_URLS from "../../summaryapi/apiUrls";
import favicon from "../../assets/images/V1LOGO.png"; // Your logo
import {
  FaBars,
  FaChevronDown,
  FaHome,
  FaBuilding,
  FaUsers,
  FaQrcode,
  FaProjectDiagram,
  FaCircle,
  FaMoneyBillWave,
  FaBolt,
  FaGift,
  FaClipboardList,
  FaChartLine,
  FaWallet,
  FaTachometerAlt,
  FaChevronRight,
  FaShoppingCart,
  FaBook 
} from "react-icons/fa";
import { IoPersonCircleOutline } from "react-icons/io5";
import { IoExitOutline } from "react-icons/io5";
import { AuthContext } from "../../common/index";
const adminUsername = sessionStorage.getItem("adminUsername");

// Helper function: copies sessionStorage to localStorage and opens URL in new tab.
const openInNewTabWithSession = (url) => {
  const sessionData = {};
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    sessionData[key] = sessionStorage.getItem(key);
  }
  console.log("Storing shared session:", sessionData);
  localStorage.setItem("sharedSession", JSON.stringify(sessionData));
  const newUrl = url.includes("?") ? `${url}&shareSession=true` : `${url}?shareSession=true`;
  console.log("Opening URL in new tab:", newUrl);
  window.open(newUrl, "_blank", "noopener,noreferrer");
};

// Function to handle right-click event on the menu items
const handleRightClick = (e, url) => {
  e.preventDefault();
  window.open(url, "_blank");
};

const VerticalNavWrapper = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const location = useLocation();
  const currentPath = location.pathname;
  const { permissions, isLoading, adminMode } = useContext(AuthContext);
  const sessionAdminMode = sessionStorage.getItem("adminMode");
  const handleSubMenuToggle = (label) => {
    // Only toggle submenu if sidebar is open
    if (isSidebarOpen) {
      setOpenSubMenu((prevState) => (prevState === label ? null : label));
    } else {
      // If sidebar is closed, just open the sidebar
      setIsSidebarOpen(true);
    }
  };
  useEffect(() => {
    const activeSubMenu = navItems.find((item) =>
      item.content?.some((subItem) => subItem.to === currentPath)
    );
    if (activeSubMenu) {
      setOpenSubMenu(activeSubMenu.label);
    } else {
      setOpenSubMenu(null);
    }
  }, [currentPath]);

  const MainNav = [{ label: "Home", to: "/dashboards/crm", icon: <FaHome /> }];

  const CompanyNav = [
    {
      label: "MASTERS",
      icon: <FaBuilding />,
      content: [
        { label: "Create District", to: "/addcompany/district", screenId: "1" },
        { label: "Create Company", to: "/addcompany/company", screenId: "2" },
        { label: "Create Group", to: "/addcompany/group", screenId: "3" },
        { label: "Create Employee", to: "/addcompany/employee" },
        { label: "Change Pwd", to: "/addcompany/changepassword", screenId: "6" },
        { label: "Add A Banners", to: "/" },
        { label: "Mobile App Permissions", to: "/" },
        { label: "Add Announcements", to: "/" },
        { label: "Add Media Announcements", to: "/" },
        { label: "Get Members Pwd", to: "/" },
        { label: "Roles And Responsibilities", to: "/addcompany/rolesandresponsbilities" },
      ],
    },
  ];

  const UploadPoints = [
    {
      label: "Upload Points",
      icon: <FaWallet />,
      content: [
        { label: "Upload Admin Electrician Points", to: "/uploadPoints/electriciantransferpoints"},
      ],
    },
  ];

  const PersonnelNav = [
    {
      label: "Create/View",
      icon: <FaUsers />,
      content: [
        { label: "Manager", to: "/addpersonnel/manager", screenId: "7" },
        { label: "Sales Executive", to: "/addpersonnel/representative", screenId: "8" },
        { label: "Dealer", to: "/addpersonnel/dealer", screenId: "9" },
        { label: "SalesBoy", to: "/addpersonnel/salesboy", screenId: "10" },
        { label: "Electrician", to: "/addpersonnel/electrician", screenId: "11" },
      ],
    },
  ];

  const SchemesNav = [
    {
      label: "Schemes",
      icon: <FaClipboardList />,
      content: [
        { label: "Dealer Scheme", to: "/giftscheme/dealergiftscheme", screenId: "31"  },
        { label: "SalesBoy Scheme", to: "/" },
        { label: "Electrician Scheme", to: "/giftscheme/electriciangiftscheme", screenId: "12" },
      ],
    },
  ];

  const QrNav = [
    {
      label: "Qrcode",
      icon: <FaQrcode />,
      content: [
        { label: "Generate QR Codes", to: "/qrcode/qrcodes"},
        { label: "NEW QR CODES", to: "/qrcode/qrreports"},
        { label: "Used QR CODES", to: "/qrcode/usedqrcodes"},
        { label: "Search Qr Code Status", to: "/qrcode/SearchQrCodeStatus"},
      ],
    },
  ];

  const PointsNav = [
    {
      label: "Transfer Points",
      icon: <FaMoneyBillWave />,
      content: [
        { label: "Dealer To Electrician", to: "/points/electriciantransferpoints", screenId: "16" },
        { label: "Dealer To Salesboy", to: "/points/salesboytransferpoints", screenId: "17" },
      ],
    },
  ];

  const GiftElectrician = [
    {
      label: "GIFT Management Electrician",
      icon: <FaGift />,
      content: [
        { label: "Select Gift", to: "/giftmanagementelectirician/reedemgift" ,screenId: "18" },
        { label: "Gift Delivery Pending or Delivered", to: "/giftmanagementelectirician/giftdeveliveredorpending" ,screenId: "19"},
        { label: "Make Electrican Points Empty", to: "/" },
      ],
    },
  ];



  const GiftSalesboy = [
    {
      label: "GIFT Management SalesBoy",
      icon: <FaGift />,
      content: [
        { label: "Select Gift", to: "/" },
        { label: "Gift Delivery Pending or Delivered", to: "/" },
      ],
    },
  ];

  const TotalReports = [
    {
      label: "Reports",
      icon: <FaChartLine />,
      content: [
        { label: "Electrician Reports", to: "/records/electricianReports", screenId: "20" },
        { label: "Dealer Reports", to: "/records/dealerReports", screenId: "24" },
      ],
    },
  ];


  const PersonalDashBoard = [
    {
      label: "Personal DashBoard",
      icon: <FaTachometerAlt  />,
      content: [
        { label: "Electrician Dashboard", to: "/personaldashboard/electriciandashboard",  screenId: "21"},
        { label: "Dealer Dashboard", to: "/personaldashboard/dealerdashboard",  screenId: "23"}
      ],
    },
  ];


 


  const LedgerReport = [
    {
      label: "Ledger Report",
      icon: <FaBook />,
      content: [
        { label: "Electrician LedgerReport", to: "/reports/electricianledgerreports",  screenId: "22"},
        { label: "Dealer LedgerReport", to: "/reports/dealerledgerreports",  screenId: "33"},
      ],
    },
  ];





  const GiftDealer = [
    {
      label: "GIFT Management Dealer",
      icon: <FaGift />,
      content: [
        { label: "Update Gift Dispatch details", to: "/giftmanagementDealer/giftdeveliveredorpendingdealer", screenId: "32" },
        { label: "Gift Delivery Pending", to: "/" },
        { label: "Gift Delivered", to: "/" },
      ],
    },
  ];

  const SaleOrders = [
    {
      label: "Sale Orders",
      icon: <FaShoppingCart />,
      content: [
        { label: "Item Management", to: "/saleorders/item-management" , screenId: "25" },
        { label: "Item Positions", to: "/saleorders/item-positions" , screenId: "26" },
        { label: "Order Management", to: "/saleorders/order-management" , screenId: "27" },
        { label: "Edit Orders", to: "/saleorders/edit-orders" , screenId: "28" },
        { label: "In voice", to: "/saleorders/in-voice" , screenId: "29" },
        { label: "Order History", to: "/saleorders/dealer-orderhistory" , screenId: "30" },
      ],
    },
  ];

  const navItems = [
    ...MainNav,
    ...CompanyNav,
    ...UploadPoints,
    ...PersonnelNav,
    ...SchemesNav,
    ...PointsNav,
    ...QrNav,
    ...GiftDealer,
    ...GiftElectrician,
    ...GiftSalesboy,
    ...TotalReports,
    ...PersonalDashBoard,
    ...LedgerReport,
    ...SaleOrders
  ];

  const filteredNavItems = navItems
  .map(item => {
    // Always include "Home" for both Admin and Employee
    if (item.label === "Home") {
      return item;
    }

    if (item.label === "Personal DashBoard" || item.label === "Ledger Report" || item.label === "Delear Dashboard" || item.label === "Item Positions" || item.label === "Edit Orders") {
      return null; // Exclude these items from the sidebar
    }





    if (item.label === "Sale Orders") {
      if (item.content) {
        const filteredContent = item.content.filter(subItem => subItem.label !== "Item Positions" && subItem.label !== "Edit Orders"  && subItem.label !== "In voice" &&  subItem.label !== "Order History" );
        if (filteredContent.length > 0) {
          return {...item, content: filteredContent};
        }
        return null;
      }
      return item;
    }


    if (sessionAdminMode === "Employee") {
      if (item.content && item.content.length > 0) {
        // Filter sub-items that have a screenId and check if is_access = 1
        const filteredSubItems = item.content.filter(subItem => {
          if (subItem.screenId && permissions[subItem.screenId]) {
            return permissions[subItem.screenId].is_access; // Keep if is_access = 1
          }
          return false; // Hide if no permission exists
        });

        // If there are valid sub-items, return the item with only those sub-items
        return filteredSubItems.length > 0 ? { ...item, content: filteredSubItems } : null;
      } else {
        // If no sub-items exist, return the main item only if it has a screenId and is_access = 1
        return item.screenId && permissions[item.screenId]?.is_access ? item : null;
      }
    }
    
    // If Admin, return all items
    return item;
  })
  .filter(Boolean); // Remove null values to exclude unwanted items
 // Remove null values to exclude unwanted items
  const isNavItemSelected = (item) =>
    currentPath === item.to ||
    (item.content && item.content.some((subItem) => currentPath === subItem.to));

  const renderNavItems = () => {
    return filteredNavItems.map((item, index) => {
      const isSelected = isNavItemSelected(item);
      if (item.content) {
        return (
          <li key={index} className="nav-item">
            <Link
              to={item.to || "#"}
              className={`d-flex align-items-center py-2 px-3 text-white text-decoration-none rounded`}

              onClick={(e) => {
                e.preventDefault();
                if (!isSidebarOpen) {
                  setIsSidebarOpen(true); // Only open sidebar if closed
                } else {
                  handleSubMenuToggle(item.label); // Only toggle submenu if sidebar is open
                }
              }}
              style={{
                backgroundColor: isSelected ? "rgba(0, 0, 0, 0.3)" : "transparent",
                transition: "background-color 0.3s ease",
              }}
            >
              <span
                className={`mr-3 ${!isSidebarOpen ? "icon-large" : ""}`}
                style={{ fontSize: isSidebarOpen ? "20px" : "24px" }}
              >
                {item.icon}
              </span>
              {isSidebarOpen && (
                <>
                  <span className="text-uppercase" style={{ fontSize: "10px", paddingLeft: "10px" }}>
                    {item.label}
                  </span>
                  <FaChevronDown
                    style={{
                      marginLeft: "auto",
                      transform: openSubMenu === item.label ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </>
              )}
            </Link>
            {isSidebarOpen && openSubMenu === item.label && (
              <ul className="list-unstyled pl-3">
                {item.content.map((subItem, subIndex) => {
                  const isSubItemSelected = currentPath === subItem.to;
                  return (
                    <li key={subIndex} className="nav-item">
                      <Link
                        to={subItem.to || "#"}
                        className={`d-flex align-items-center py-2 px-3 text-white text-decoration-none rounded`}
                        onContextMenu={(e) => {
                          handleRightClick(e, subItem.to);
                        }}
                        style={{
                          backgroundColor: isSubItemSelected ? "rgba(0, 0, 0, 0.3)" : "transparent",
                          transition: "background-color 0.3s ease",
                          paddingLeft: isSidebarOpen ? "30px" : "20px",
                          marginTop: subIndex === 0 ? "10px" : "0",
                        }}
                      >
                        {isSidebarOpen && (
                          <span className="text-uppercase" style={{ fontSize: "11px", paddingLeft: "10px" }}>
                            {subItem.label}
                          </span>
                        )}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        );
      } else {
        return (
          <li key={index} className="nav-item">
         <Link
            to={item.to || "#"}
            className={`d-flex align-items-center py-2 px-3 text-white text-decoration-none rounded`}
            onClick={() => {
              if (!isSidebarOpen) setIsSidebarOpen(true);
            }}
            style={{
              backgroundColor: isSelected ? "rgba(0, 0, 0, 0.3)" : "transparent",
              transition: "background-color 0.3s ease",
            }}
          >

              
              <span
                className={`mr-3 ${!isSidebarOpen ? "icon-large" : ""}`}
                style={{ fontSize: isSidebarOpen ? "20px" : "24px" }}
              >
                {item.icon}
              </span>
              {isSidebarOpen && (
                <span className="text-uppercase" style={{ fontSize: "12px", paddingLeft: "10px" }}>
                  {item.label}
                </span>
              )}
            </Link>
          </li>
        );
      }
    });
  };

  const clearSessionAndCookies = () => {
    const ConfirmLogout = ({ closeToast }) => (
      <div>
        <p>Are you sure you want to logout?</p>
        <div style={{ display: "flex", justifyContent: "space-around", marginTop: "10px" }}>
          <button
            className="btn btn-danger"
            onClick={() => {
              sessionStorage.clear();
              toast.success("Logged out successfully!", { autoClose: 3000 });
              closeToast();
              setTimeout(() => {
                window.location.href = "/login";
              }, 2000);
            }}
          >
            Yes, Logout
          </button>
          <button className="btn btn-secondary" onClick={closeToast}>
            No, Cancel
          </button>
        </div>
      </div>
    );
    toast.warn(<ConfirmLogout />, {
      position: "top-center",
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      hideProgressBar: true,
    });
  };

  return (
    <Fragment>
      <div
        className={`sidebar text-white position-fixed ${isSidebarOpen ? "sidebar-open" : "sidebar-collapsed"}`}
        style={{
          height: "100vh",
          width: isSidebarOpen ? "260px" : "80px",
          position: "fixed",
          transition: "width 0.3s ease",
          top: 0,
          left: 0,
          zIndex: 1000,
          overflow: "hidden", // Prevent content overflow
          background: "linear-gradient(135deg,rgb(172, 37, 44), #ff4b5c,rgb(172, 35, 35))",
        }}
      >
        <div className="d-flex flex-column justify-content-between align-items-center p-4" style={{ marginTop: isSidebarOpen ? "4rem" : "2rem" }}>
          <Link to="/dashboards/crm" className={`d-flex flex-column align-items-center ${!isSidebarOpen ? "d-none" : ""}`}>
            <div className="mt-2 d-flex align-items-center">
              <img
                src={favicon}
                alt="Logo"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  marginRight: "10px"
                }}
              />
              <h1 className="mb-0 text-white">
                {adminMode === "Admin" ? adminMode : ""}
              </h1>
            </div>
          </Link>
        </div>
  
        <div className="p-2">
          <ul className="list-unstyled">{renderNavItems()}</ul>
        </div>
        
        <div
          className="logout-container position-absolute w-100"
          style={{
            bottom: 0,
            backgroundColor: "rgb(172, 35, 35)",
            padding: "10px 0",
            textAlign: "center",
            cursor: "pointer",
            zIndex: 1000,
          }}
          onClick={clearSessionAndCookies}
        >
          <IoExitOutline size={isSidebarOpen ? 20 : 24} className="text-white" />
          <span className={`text-white ${!isSidebarOpen ? "d-none" : ""}`}>Logout</span>
        </div>
  
        <div
          className="sidebar-toggle-btn position-absolute"
          style={{
            top: isSidebarOpen ? "60px" : "20px",
            right: "20px",
            cursor: "pointer",
            zIndex: 1000,
            transition: "top 0.3s ease"
          }}
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          {isSidebarOpen ? (
            <FaBars style={{ fontSize: "28px" }} />
          ) : (
            <FaChevronRight style={{ fontSize: "28px" }} />
          )}
        </div>
      </div>
      
      <div
        className="main-content"
        style={{
          marginLeft: isSidebarOpen ? "250px" : "80px",
          transition: "margin-left 0.3s ease",
          padding: "20px",
        }}
      ></div>
    </Fragment>
  );
};

export default VerticalNavWrapper;